import React from 'react';

import {
	ConnectionsByLineMenu,
	type ConnectionsByLineMenuProps,
} from './ConnectionsByLineMenu.tsx';
import { EmbeddedConnectionsByLineMenu } from './EmbeddedConnectionsByLineMenu.tsx';

export type BylineConnectionsMenuContentProps = ConnectionsByLineMenuProps & {
	isEmbeddedMenu: boolean;
};

/** Maps each menu's supported inputs without exposing panel actions to embedded views. */
export const BylineConnectionsMenuContent = ({
	isEmbeddedMenu,
	...props
}: BylineConnectionsMenuContentProps): React.JSX.Element =>
	isEmbeddedMenu ? (
		<EmbeddedConnectionsByLineMenu
			links={props.links}
			relatedContentLinks={props.relatedContentLinks}
			relatedContentLoading={props.relatedContentLoading}
			refreshLinkUrl={props.refreshLinkUrl}
			onNavigate={props.onNavigate}
		/>
	) : (
		<ConnectionsByLineMenu {...props} />
	);
